module.exports = __webpack_public_path__ + "files/6d652b69146b9b322c6c020c7a554ee5.svg";